// src/proxy.ts
var proxy = (cb) => {
  let proxy2 = (path) => new Proxy(() => {
  }, {
    get: (target, prop) => {
      if (prop == "toString")
        return () => `Client(${path.join(".")})`;
      return proxy2([...path, prop]);
    },
    apply: (target, thisArg, args) => {
      if (path.length == 0)
        throw new Error("Cannot call root controller");
      return cb(path, ...args);
    }
  });
  return proxy2([]);
};
export {
  proxy
};
//# sourceMappingURL=index.mjs.map